import { IPatient } from "./IPatient";
import { ISensor } from "./ISensor";

export interface IAlarm {
  id: number;
  value: string;
  reason: string;
  disabled: boolean;
  sensorId: number;
  patientId: number;
  userId: number;
  createdAt: string;
  updatedAt: string;
  sensor: ISensor;
  patient: IPatient;
  served?: boolean;
  sensorType: string;
  // allarme di prova lanciato da Setup: etichetta PROVA, fuori dalle Statistiche
  isTest?: boolean;
  // chi ha lanciato la prova
  createdBy?: string | null;
}

export const isTestAlarm = (alarm: IAlarm | undefined | null) => {
  return alarm?.isTest === true;
};

// riga sotto un allarme di prova
export const testAlarmNote = (alarm: IAlarm | undefined | null) => {
  const by = (alarm?.createdBy ?? "").trim();
  return (by ? "Prova inviata da " + by : "Prova") + " - nessuno ha bisogno di aiuto";
};
